import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ExpandMore } from "@mui/icons-material";

import { getFaq } from "../../redux/action-creators/profileAction";

import LeftSidebar from "../../components/sidebars/LeftSidebar";

import { getTimeDiff, capitalize, isJsonString, formatTextWithLineBreaks } from "../../utils/helper";

import { UserCommonStyles } from "../../styles/CommonStyles";
import { ProfileStyle } from "./ProfileStyle";

const HelpCenter = () => {
  const { t: translation } = useTranslation();
  const dispatch = useDispatch();
  const commonStyle = UserCommonStyles();
  const styleClasses = ProfileStyle();
  const isLoggedIn = Boolean(localStorage.getItem("userData"));
  // const [FaqList, setFaqList] = useState([]);

  const [loading, setLoading] = useState<boolean>(false);
  const [state, setState] = useState({
    FaqList: [],
    offset: 0,
    hasMore: true,
  });
  const PAGE_SIZE = 100;

  /**
   * get all faqs
   */
  const getAllFaq = async (firstLoad: boolean) => {
    if (!firstLoad && (loading || !state.hasMore)) return;
    setLoading(true);
    const offset = firstLoad ? 0 : state.offset;
    let result: any = await dispatch(getFaq(offset));
    if (result && result?.length > 0) {
      setState((prevState) => ({
        ...prevState,
        offset: offset + PAGE_SIZE,
        FaqList: firstLoad ? result : prevState.FaqList.concat(result),
        hasMore: result.length === PAGE_SIZE,
      }));
    } else {
      if (result) {
        setState((prevState) => ({
          ...prevState,
          FaqList: firstLoad ? result : prevState.FaqList.concat(result),
          hasMore: false,
        }));
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getAllFaq(true);
  }, []);

  return (
    <Box>
      <Box className={commonStyle.windowColor}>
        <Grid container>
          {isLoggedIn ? (
            <Grid item md={3}>
              <LeftSidebar />
            </Grid>
          ) : null}
          <Grid item md={isLoggedIn ? 9 : 12}>
            <Box className={`${commonStyle.p20} ${commonStyle.mt20}`}>
              <Typography variant="h6" className={`${commonStyle.grey} ${commonStyle.mb15} ${commonStyle.fontWeight600}`}>
                {translation("help_center_head")}
              </Typography>
              {/* <InfiniteScroll
                dataLength={state?.FaqList?.length}
                next={() => getAllFaq(true)}
                hasMore={state?.hasMore}
                loader={(() => {
                  if (loading) {
                    return <div className="loaing-area">Loading...</div>;
                  }
                })()}
                scrollThreshold="100px"
              > */}
              <Box className={`${styleClasses.helpAccordion} ${commonStyle.p20}`}>
                {state.FaqList.length > 0
                  ? state.FaqList.map((i, index) => (
                      <Accordion key={i.id || index} className={styleClasses.accordionShadow}>
                        <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
                          <Typography className={`${commonStyle.textUpper}`}>
                            <strong>{i.name}</strong>
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Typography
                            className={`${commonStyle.grey}`}
                            dangerouslySetInnerHTML={{
                              __html: formatTextWithLineBreaks(i.description),
                            }}
                          ></Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))
                  : loading
                  ? translation("loading")
                  : translation("missing_record")}
              </Box>
              {state.hasMore && state.FaqList.length > 0 ? (
                <Box className={`${commonStyle.mt20}`}>
                  <Button variant="contained" onClick={() => getAllFaq(false)} disabled={loading}>
                    {loading ? translation("loading") : "Load more"}
                  </Button>
                </Box>
              ) : null}
              {/* </InfiniteScroll> */}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default HelpCenter;
